module.exports = __webpack_public_path__ + "static/media/IUP_L2.9b5f7233.svg";